// extracted by mini-css-extract-plugin
export default {"page":"loading_page__rRkfb"};